import SocialLoopMetricCard from './SocialLoopMetricCard';
import {
  BODY2_DEFAULT,
  formatCountOfTotal,
  formatPercentDisplay,
  normalizeMetric,
} from '../utils/metricFormatters';

const TimeToFirstConnection = ({ metrics }) => {
  const timeValue =
    metrics?.timeToFirstConnection != null && metrics.timeToFirstConnection !== ''
      ? String(metrics.timeToFirstConnection)
      : '0min';

  const stats = normalizeMetric(metrics?.timeToFirstConnectionStats);
  const body2Text = stats
    ? `${formatPercentDisplay(stats.percentage)} · ${formatCountOfTotal(stats.count, stats.totalCount)} in selected period`
    : BODY2_DEFAULT;

  return (
    <SocialLoopMetricCard
      title="Time To First Connection"
      value={timeValue}
      description={body2Text}
    />
  );
};

export default TimeToFirstConnection;
